import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import Alert from "../../components/Alert";
import MyPage from "../../../src/MyPage";
import SubTabsParameters from "../../../src/SubTabsParameters";
import { isSuperAdmin } from "./../../helpers/user.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';

  export default class ParametersCountries extends Component{ 

    constructor(props){
      super(props);

      this.state={
          countries:[],
          modalTitle:"",
          countryname:"",
          countryid:0,
          geographicallocation:"",
          isactive: true,
          region: {
            regionname:""
          },

          CountryIdFilter:"",
          CountryNameFilter:"",
          GeographicalLocationFilter:"",
          IsactiveFilter:"",
          RegionNameFilter:"",
          countriesWithoutFilter:[],
          regionNames: [],
          countryNames: [],
          countryExists: false,
          loading: true,
          uniqueCountryIdsSuppliers:[],
          uniqueCountryIdsWarehouses:[],
          uniqueCountryIdsContainers:[],
          uniqueCountryIdsProducts:[],
          uniqueCountryIdsForecasts:[],
          uniqueCountryIdsCostGrid:[],
          uniqueCountryIdsReturns:[],
      }
  }

  FilterFn(){
    var CountryIdFilter=this.state.CountryIdFilter;
    var CountryNameFilter = this.state.CountryNameFilter;
    var GeographicalLocationFilter = this.state.GeographicalLocationFilter;
    var IsactiveFilter = this.state.IsactiveFilter;
    var RegionNameFilter = this.state.RegionNameFilter;

    var filteredData=this.state.countriesWithoutFilter.filter(
        function(el){
            return el.countryid.toString().toLowerCase().includes(
                CountryIdFilter.toString().trim().toLowerCase()
            )&&
            el.countryname.toString().toLowerCase().includes(
                CountryNameFilter.toString().trim().toLowerCase()
            )&&
            el.isactive.toString().toLowerCase().includes(
                IsactiveFilter.toString().trim().toLowerCase()
            )&&
            el.region.regionname.toString().toLowerCase().includes(
                RegionNameFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({countries:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.countriesWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({countries:sortedData});

}

changeCountryIdFilter = (e)=>{
  this.state.CountryIdFilter=e.target.value;
  this.FilterFn();
}
changeCountryNameFilter = (e)=>{
  this.state.CountryNameFilter=e.target.value;
  this.FilterFn();
}

changeGeographicalLocationFilter = (e)=>{
  this.state.GeographicalLocationFilter=e.target.value;
  this.FilterFn();
}


changeIsActiveFilter = (e)=>{
  this.state.IsactiveFilter=e.target.value;
  this.FilterFn();
}

changeRegionNameFilter = (e)=>{
  this.state.RegionNameFilter=e.target.value;
  this.FilterFn();
}


refreshList = () => {
  axiosService.get('/countries/')
    .then((response) => {
      const data = response.data?.results ?? response.data;
      this.setState({ countries: data, countriesWithoutFilter: data, loading: false });
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
      this.setState({ loading: false });
    });
};


fetchRegionNames() {
  axiosService.get('/regionnames/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const regionNames = filteredData.map(item => item.regionname);
      this.setState({ regionNames: regionNames });
    })
    .catch(error => {
      console.error("Error fetching region names:", error);
    });
}


fetchCountryNames() {
  axiosService.get('/countries/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const countryNames = data.map(item => item.countryname);
      this.setState({ countryNames: countryNames });
    })
    .catch(error => {
      console.error("Error fetching country names:", error);
    });
}

checkCountryExists = (event) => {
  const enteredCountry = event.target.value.toLowerCase(); // Convert to lowercase
  const { countryNames } = this.state;
  const countryExists = countryNames.some((country) => country.toLowerCase() === enteredCountry);
  this.setState({ countryExists });
};



fetchCountryIdsSuppliers() {
  axiosService.get('/supplierscreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueCountryIdsSuppliers = [...new Set(data.map((item) => item.countryid))];
      this.setState({ uniqueCountryIdsSuppliers: uniqueCountryIdsSuppliers });
    })
    .catch((error) => {
      console.error('Error fetching Supliers data:', error);
    });
}

fetchCountryIdsWarehouses() {
  axiosService.get('/warehousescreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueCountryIdsWarehouses = [...new Set(data.map((item) => item.countryid))];
      this.setState({ uniqueCountryIdsWarehouses: uniqueCountryIdsWarehouses });
    })
    .catch((error) => {
      console.error('Error fetching Warehouses data:', error);
    });
}

fetchCountryIdsContainers() {
  axiosService.get('/containerscreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueCountryIdsContainers = [...new Set(data.map((item) => item.origincountryid))];
      this.setState({ uniqueCountryIdsContainers: uniqueCountryIdsContainers });
    })
    .catch((error) => {
      console.error('Error fetching Containers data:', error);
    });
}

fetchCountryIdsProducts() {
  axiosService.get('/defaultproductscreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueCountryIdsProducts = [...new Set(data.map((item) => item.origincountryid))];
      this.setState({ uniqueCountryIdsProducts: uniqueCountryIdsProducts });
    })
    .catch((error) => {
      console.error('Error fetching Products data:', error);
    });
}

fetchCountryIdsForecasts() {
  axiosService.get('/forecastscreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueCountryIdsForecasts = [...new Set(data.map((item) => item.countryid))];
      this.setState({ uniqueCountryIdsForecasts: uniqueCountryIdsForecasts });
    })
    .catch((error) => {
      console.error('Error fetching Forecasts data:', error);
    });
}


fetchCountryIdsCostGrid() {
  axiosService.get('/costgridcreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueCountryIdsCostGrid = [...new Set(data.map((item) => item.countryid))];
      this.setState({ uniqueCountryIdsCostGrid: uniqueCountryIdsCostGrid });
    })
    .catch((error) => {
      console.error('Error fetching CostGrid data:', error);
    });
}


fetchCountryIdsReturns() {
  axiosService.get('/returnscreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueCountryIdsReturns = [...new Set(data.map((item) => item.countryid))];
      this.setState({ uniqueCountryIdsReturns: uniqueCountryIdsReturns });
    })
    .catch((error) => {
      console.error('Error fetching CostGrid data:', error);
    });
}


componentDidMount(){
  this.refreshList();
  this.fetchRegionNames();
  this.fetchCountryNames();
  this.fetchCountryIdsSuppliers();
  this.fetchCountryIdsWarehouses();
  this.fetchCountryIdsContainers();
  this.fetchCountryIdsProducts();
  this.fetchCountryIdsForecasts();
  this.fetchCountryIdsCostGrid();
  this.fetchCountryIdsReturns();
}

changeCountryName =(e)=>{
  this.setState({countryname:e.target.value});
}

changeGeographicalLocation =(e)=>{
  this.setState({geographicallocation:e.target.value});
}


changeIsActive = (event) => {
  const isChecked = event.target.checked;
  this.setState({ isactive: isChecked });
};

changeRegionName =(e)=>{
  this.setState({regionname:e.target.value});
}



addClick(){
  this.setState({
      modalTitle:"Add Country",
      countryid:0,
      countryname: "",
      isactive: true,
      regionname: "",
      countryExists: false, // Reset the countryExists state to false
      
  });
}
editClick(dep) {
  this.setState({
    modalTitle: "Edit Country",
    countryid: dep.countryid,
    countryname: dep.countryname,
    geographicallocation: dep.geographicallocation,
    isactive: dep.isactive,
    regionname: dep.region.regionname,
    initialCountryname: dep.countryname,
    initialRegionname: dep.region.regionname,
    initialGeographicalLocation: dep.geographicallocation,
    initialIsactive: dep.isactive,
    countryExists: false, // Reset the countryExists state to false
  });
}

createClick() {
  const { countryname, geographicallocation, isactive, regionname, countryNames } = this.state;

  if (!countryname) {
    alert('Country Name is required');
    return;
  }
  if (countryNames.some(name => name.toLowerCase() === countryname.toLowerCase())) {
    alert('Country already exists. Please provide a unique Country Name.');
    return;
  }
  

  if (!regionname) {
    alert('Region Name is required');
    return;
  }


  axiosService.post('/countriescreate/', {
    countryname: countryname,
    geographicallocation: geographicallocation,
    isactive: isactive,
    regionname: regionname
  })
    .then(result => {
      alert('Country created');
      this.refreshList();
      //window.location.reload();
    })
    .catch(error => {
      alert('Failed');
    });
}

updateClick(id) {
  const { countryname, geographicallocation, isactive, regionname,initialCountryname, initialRegionname, initialGeographicalLocation, initialIsactive, countryNames } = this.state;

  // Check if any changes are detected
  if (
    countryname === initialCountryname &&
    geographicallocation === initialGeographicalLocation &&
    isactive === initialIsactive &&
    regionname === initialRegionname
  ) {
    alert('No changes detected');
    return;
  }

  if (
    countryNames.some((existingCountry) => existingCountry.toLowerCase() === countryname.toLowerCase() && countryname !== initialCountryname
    )
  ) {
    this.setState({ countryname : initialCountryname });
    return;
  }



  if (!countryname) {
    alert('Country Name is required');
    return;
  }

  if (!regionname) {
    alert('Region Name is required');
    return;
  }

  
  axiosService.patch('/countries/' + id + '/', {
    countryid: this.state.countryid,
    countryname: this.state.countryname,
    geographicallocation: this.state.geographicallocation,
    isactive: this.state.isactive,
    regionname : this.state.regionname
  })
    .then(result => {
      alert('Update successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}


copyClick() {
  const { countryname, geographicallocation, isactive, regionname,initialCountryname, initialRegionname, initialGeographicalLocation, initialIsactive, countryNames } = this.state;


  if (
    countryNames.some((existingCountry) => existingCountry.toLowerCase() === countryname.toLowerCase() && countryname !== initialCountryname
    )
  ) {
    this.setState({ countryname : initialCountryname });
    return;
  }

  if (countryNames.some(name => name.toLowerCase() === countryname.toLowerCase())) {
    alert('Country already exists. Please provide a unique Country Name.');
    return;
  }
  

  if (!countryname) {
    alert('Country Name is required');
    return;
  }

  if (!regionname) {
    alert('Region Name is required');
    return;
  }

  
  axiosService.post('/countriescreate/', {
    countryname: this.state.countryname,
    geographicallocation: this.state.geographicallocation,
    isactive: this.state.isactive,
    regionname : this.state.regionname
  })
    .then(result => {
      alert('Country created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}


deleteClick(id) {
  if (this.state.uniqueCountryIdsSuppliers.includes(id)) {
    alert('Cannot delete this Country as it is in the Suppliers Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueCountryIdsWarehouses.includes(id)) {
    alert('Cannot delete this Country as it is in the Warehouses Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueCountryIdsContainers.includes(id)) {
    alert('Cannot delete this Country as it is in the Containers Table !');
    return; // Exit the function without making the delete request
  }
  if (this.state.uniqueCountryIdsProducts.includes(id)) {
    alert('Cannot delete this Country as it is in the Products Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueCountryIdsForecasts.includes(id)) {
    alert('Cannot delete this Country as it is in the Forecasts Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueCountryIdsCostGrid.includes(id)) {
    alert('Cannot delete this Country as it is in the CostGrid Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueCountryIdsReturns.includes(id)) {
    alert('Cannot delete this Country as it is in the Returns Table !');
    return; // Exit the function without making the delete request
  }


  if (window.confirm('Are you sure?')) {
    axiosService.delete('/countries/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        //window.location.reload();
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      countries,
      modalTitle,
      countryid,
      countryname,
      geographicallocation,
      isactive,
      regionname,
      countryExists,
      loading
  }=this.state;

  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsParameters />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Add Country
</button>
<div className="table-container-single">
<table className="table table-striped custom-table">
<thead>
<tr  className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
      onChange={this.changeCountryIdFilter}
      style={{ width: "70px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>

      </div>
      CountryId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
      onChange={this.changeCountryNameFilter}
      style={{ width: "200px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>

      </div>
      CountryName
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      GeographicalLocation
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
      onChange={this.changeIsActiveFilter}
      style={{ width: "70px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>
      </div>
      Is Active
  </th>
  
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
      onChange={this.changeRegionNameFilter}
      style={{ width: "200px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>

      </div>
      RegionName
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {countries.map(dep=>
      <tr key={dep.countryid} className="row-hover">
          <td className="table-text">{dep.countryid}</td>
          <td className="table-text">{dep.countryname}</td>
          <td className="table-text">{dep.geographicallocation}</td>
          <td className="table-text">{dep.isactive.toString()}</td>
          <td className="table-text">{dep.region.regionname}</td>
          <td className="table-text">

          <div style={{ display: "flex", justifyContent: "center" }}>
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.countryid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-primary m-2"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal1"
          onClick={()=>this.editClick(dep)}
          style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
            >
             Copy
          </button>

          </div>

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }}>{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Country Name</span>
          <input
            type="text"
            className={`form-control ${countryExists ? "is-invalid" : ""}`}
            value={countryname}
            onChange={this.changeCountryName}
            onBlur={this.checkCountryExists} // Check SAP code existence on blur (when user moves out of the field)
            style={{ fontSize: "12px" }}
          />
          {countryExists && <div className="invalid-feedback" style={{ fontSize: "12px" }}>Country already exists.</div>}
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>GeographicalLocation</span>
          <input type="text" className="form-control" value={geographicallocation} onChange={this.changeGeographicalLocation} 
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Isactive</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={isactive}
            onChange={this.changeIsActive}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Region</span>
          <select
            className="form-select"
            value={this.state.regionname}
            onChange={(event) => this.setState({ regionname: event.target.value })}
            style={{ fontSize: "12px" }}
          >
            <option value="">Select a region</option>
            {this.state.regionNames.map((region) => (
              <option key={region} value={region}>
                {region}
              </option>
            ))}
          </select>
        </div>
        
        

        {countryid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {countryid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(countryid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="exampleModal1" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }}>{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Country Name</span>
          <input
            type="text"
            className={`form-control ${countryExists ? "is-invalid" : ""}`}
            value={countryname}
            onChange={this.changeCountryName}
            onBlur={this.checkCountryExists} // Check SAP code existence on blur (when user moves out of the field)
            style={{ fontSize: "12px" }}
          />
          {countryExists && <div className="invalid-feedback" style={{ fontSize: "12px" }}>Country already exists.</div>}
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>GeographicalLocation</span>
          <input type="text" className="form-control" value={geographicallocation} onChange={this.changeGeographicalLocation} 
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Isactive</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={isactive}
            onChange={this.changeIsActive}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Region</span>
          <select
            className="form-select"
            value={this.state.regionname}
            onChange={(event) => this.setState({ regionname: event.target.value })}
            style={{ fontSize: "12px" }}
          >
            <option value="">Select a region</option>
            {this.state.regionNames.map((region) => (
              <option key={region} value={region}>
                {region}
              </option>
            ))}
          </select>
        </div>
        
        

        {countryid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}

        {countryid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>


</div>


  )
}


  }




